/*
 * sorting-directions-enum.ts
 * dev-utms-shop-admin
 * 
 * Last Modified: 04.07.2023
 * Modified By: Tetiana Makovii
 * 
 * Created by Tetiana Makovii on 04.07.2023
 * Copyright © 2026 Sonova AG. All rights reserved.
 */

export enum SortingDirectionsEnum {
    asc = 'asc',
    desc = 'desc',
    none = ''
}
